import { render, staticRenderFns } from "./SignatureDialog.vue?vue&type=template&id=c2141304"
import script from "./SignatureDialog.vue?vue&type=script&lang=js"
export * from "./SignatureDialog.vue?vue&type=script&lang=js"
import style0 from "./SignatureDialog.vue?vue&type=style&index=0&id=c2141304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports